import { render, staticRenderFns } from "./TaskWork.vue?vue&type=template&id=35e3fb38&scoped=true&"
import script from "./TaskWork.vue?vue&type=script&lang=js&"
export * from "./TaskWork.vue?vue&type=script&lang=js&"
import style0 from "./TaskWork.vue?vue&type=style&index=0&id=35e3fb38&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35e3fb38",
  null
  
)

export default component.exports